import { useState, useEffect, useCallback } from 'react';
import { localDraftService, type DraftData } from '@/services/LocalDraftService';
import { useToast } from '@/hooks/use-toast';

export const useLocalDraftList = () => {
  const [drafts, setDrafts] = useState<DraftData[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  // Load all drafts
  const loadDrafts = useCallback(() => {
    setLoading(true);
    try {
      const allDrafts = localDraftService.listDrafts();
      setDrafts(allDrafts);
    } catch (error) {
      console.error('Error loading drafts:', error);
      setDrafts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Delete a draft
  const deleteDraft = useCallback(async (id: string) => {
    try {
      localDraftService.deleteDraft(id);
      loadDrafts(); // Refresh the list
      toast({
        title: "Draft deleted",
        description: "The draft has been successfully deleted.",
      });
    } catch (error) {
      console.error('Error deleting draft:', error);
      toast({
        title: "Error",
        description: "Failed to delete the draft. Please try again.",
        variant: "destructive",
      });
    }
  }, [loadDrafts, toast]);

  // Load drafts on mount
  useEffect(() => {
    loadDrafts();
  }, [loadDrafts]);

  return {
    drafts,
    loading,
    loadDrafts,
    deleteDraft
  };
};